import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';
import { LocalCacheService } from '../../services/localCache.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  agentName: string = '';
  isPASUser: boolean = false;
  PASUrl: string = '';

  constructor(
    private globalService: GlobalService,
    private localCacheService: LocalCacheService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.PASUrl = environment.PASUrl;
  }
  ngOnInit(): void {
    var agentGuid =
      this.globalService.getQueryParamInfo('AgentGuid') ||
      this.localCacheService.getSessionStorage('agentGuid');
    this.agentName =
      this.globalService.getQueryParamInfo('AgentName') ||
      this.localCacheService.getSessionStorage('agentName');
    if (this.agentName && agentGuid) {
      this.isPASUser = true;
    }
  }

  clearSession() {
    if (isPlatformBrowser(this.platformId)) {
      this.localCacheService.clearAllSession();
      location.href = this.PASUrl;
    }
  }
}
